import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';

import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import CKEditorUtil from '../../../../utils/ckEditorUtil'
import efn from './AgendaUpsertPageFns'
import moment from 'moment'

function AgendaUpsertPage(props) {
  const { lang, agendaMap } = props
  const [form] = Form.useForm();
  const { TextArea } = Input
  const [langAgenda, setLangAgenda] = useState()
  const [editorData, setEditorData] = useState();
  let setFuncMap = { setLangAgenda, setEditorData, ...props.setFuncMap }
  const onFinish = values => {
    values["lang"] = lang
    values["content"] = editorData
    efn.updateAgenda(values, props, setFuncMap)
  };

  useEffect(() => {
    setLangAgenda(agendaMap[lang])
    form.setFieldsValue(agendaMap[lang])
  }, [agendaMap])

  useEffect(() => {
    form.setFieldsValue(langAgenda)
  }, [langAgenda])

  return (
    <Form
      form={form}
      layout="horizontal"
      onFinish={onFinish}
    >
      <CKEditorUtil setFuncMap={setFuncMap} defaultValue={langAgenda ? langAgenda.content : null} />
      <Form.Item
        name="id"
        style={{ minHeight: 0, margin: 0 }}
      >
        <Input type="hidden" />{langAgenda && langAgenda.lastUpdateAt && `最後更新時間: ${moment(langAgenda.lastUpdateAt).format("yyyy-MM-DD HH:mm:ss")}`}
      </Form.Item>
      <Row justify={"center"} gutter={16}>
        <Col>
          <Button type="primary" htmlType="submit">
            更新
          </Button>
        </Col>
      </Row>

    </Form>
  );
}



export default React.memo(AgendaUpsertPage);
